const reducer = (state = "", action) => {
    if (action.type === 'setApiCache') {
        return { ...action.payload, ...state }
    }
    return state;
}

export default reducer;